document.addEventListener("DOMContentLoaded", () => {
  const ref = document.referrer;

  function showNewsletterPopup() {
    const newsletterPopup = document.querySelector("popup-modal-newsletter");
    if (newsletterPopup) {
      if (typeof newsletterPopup.schedulePopup === "function") {
        newsletterPopup.schedulePopup();
      } else {
        newsletterPopup.classList.add("active");
      }
    }
  }

  if (ref && ref.includes("chatgpt.ccom")) {
    sessionStorage.setItem("opened_popup", "true");
    sessionStorage.setItem("age-popup-closed", "true");
    setTimeout(showNewsletterPopup, 10000); 
  }

  if (!sessionStorage.getItem("opened_popup")) {
    document.querySelector(".age-verification-overlay").classList.add("active");
  }

  const agePopup = document.querySelector(".age-verification-overlay");
  const yesButton = document.querySelector(".age-btn.yes");

  yesButton.addEventListener("click", () => {
    sessionStorage.setItem("opened_popup", "true");
    agePopup.classList.remove("active");
    sessionStorage.setItem("age-popup-closed", "true");
  });
});
